import React from "react";
import { textToBr } from 'src/utils/textUtils';
import parse from 'html-react-parser';
import { formattedYearMonth } from 'src/utils/dateTime';

export const BaibaiColumnsParts = ({detail}) => {

    const colums = [
        {key: 'address', name: '住所'},
        {key: 'traffic', name: '路線・バス'},
        {key: 'summary', name: '物件の特徴'},
        {key: 'total_sales', name: '販売戸数'},
        {key: 'total_of_houses', name: '総戸数'},
        {key: 'land_area', name: '土地面積'},
        {key: 'building_area', name: '建物面積'},
        {key: 'private_road', name: '私道負担・道路'},
        {key: 'built_year_month', name: '築年月'},
        {key: 'address', name: '住所'},
        {key: 'floor_area_ratio', name: '建ぺい率・容積率'},
        {key: 'dealing_time', name: '引渡可能時期'},
        {key: 'construction', name: '施工'},
        {key: 'reform', name: 'リフォーム'},
        {key: 'use_district', name: '用途地域'},
        {key: 'land_category', name: '地目'},
        {key: 'city_plan', name: '都市計画'},
        {key: 'current', name: '現況'},
        {key: 'waterway', name: '上下水道'},
        {key: 'structure', name: '構造'},
        {key: 'surroundings', name: '周辺環境'},
        {key: 'school', name: '学校名'},
        {key: 'school_traffic', name: '学校までの距離'},
        {key: 'deal_type', name: '取引形態'},
        {key: 'other_limit_matter', name: 'その他制限事項'},
        {key: 'other_overview_notice', name: 'その他概要・特記事項'},
    ]

    return (
        <>
         
                { 
                colums.map((c, i) => {
                    if(detail[c.key] && (detail[c.key] != 'undefined' && detail[c.key] != 'null')){
                        return (
                            <dl key={i}>
                                <dt>{c.name}</dt>
                                <dd>
                                    {
                                        c.key === 'built_year_month' ? formattedYearMonth(detail[c.key]) : 
                                                    (typeof detail[c.key] === 'string' ? parse(textToBr(detail[c.key])) : detail[c.key])
                                        
                                    }
                                </dd>
                            </dl>
                        )
                    }else{}
                })
                }
       
        </>
    )
}